import React from 'react';
import styles from './CalculatorHeader.module.scss';
import print from '../../../../assets/images/printer.svg';
const CalculatorHeader = () => {
  return (
    <div className={styles["container"]}>
      <div className={styles["text-section"]}>
        <div className={styles["title"]}>
          Calculate your required minimum distribution (RMD)
        </div>
        <div className={styles["sub-title"]}>
          Use this tool to calculate your RMD for the current or prior year.
        </div>
      </div>
      <div className={styles["print-section"]}>
        <button className={styles["buttonBorder"]} onClick={() => window.print()}>
          <div className={styles["print-button"]}>
            Print
          </div>
          <img src={print} alt='' className={styles["printer-img"]}/>
        </button>
      </div>
    </div>
  );
};

export default CalculatorHeader;
